module.exports = __webpack_public_path__ + "img/icon-stockpicker-calculating@2x.f9015f90.png";